// Flow additional zIndexes
export const flowZIndex = {
  hotspotCard: 900,
  carousel: 50,
};
